import _ from 'lodash';
import { v4 as UUID } from 'uuid';
import { TextFieldBuilder } from './FieldBuilder';
import NodeBuilder from './NodeBuilder';
import { isFieldGroupBlueprint, } from '../../../types/questionnaireBlueprints/questionnaireBlueprints';
export default class FieldGroupBuilder extends NodeBuilder {
    seedProviders;
    constructor(seedProviders) {
        super(seedProviders.forFieldGroup());
        this.seedProviders = seedProviders;
        this.node.id = UUID();
    }
    with(nodeBuilder) {
        return this.withFields(nodeBuilder);
    }
    withFields(fieldBuilders) {
        const builders = fieldBuilders ? _.castArray(fieldBuilders) : [];
        if (builders.length === 0) {
            builders.push(new TextFieldBuilder(this.seedProviders));
        }
        const fields = builders.map((builder) => builder.build());
        this.addFields(fields);
        return this.clone();
    }
    addFields(fields) {
        if (!this.node.fields)
            this.node.fields = [];
        const fieldList = _.castArray(fields);
        this.node.fields.push(...fieldList);
    }
    seedWith(seed) {
        this.node = _.cloneDeep(seed);
        return this.clone();
    }
    makeRepeatable({ nodeId }) {
        Object.assign(this.node, this.seedProviders.forRepeatableFieldGroupOptions());
        const repeatableFieldGroup = this.node;
        repeatableFieldGroup.repeatable = {
            repeatableAnswerNodeId: nodeId,
            minRepeatable: 0,
            maxRepeatable: 6,
            addButtonText: { en: 'Add' },
            removeButtonText: { en: 'Remove' },
        };
        return this.clone();
    }
    withPartName(partname) {
        this.node.partName = partname;
        return this.clone();
    }
    withMinRepetitions(minRepetitions) {
        if (!this.node.repeatable) {
            Object.assign(this.node, this.seedProviders.forRepeatableFieldGroupOptions());
            Object.assign(this.node.repeatable ?? {}, { minRepetitions });
        }
        else {
            Object.assign(this.node.repeatable, { minRepetitions });
        }
        return this.clone();
    }
    withTitle(title) {
        this.node.title = title;
        return this.clone();
    }
    withText(text) {
        this.node.text = text;
        return this.clone();
    }
    visible(condition) {
        this.node.visible = condition;
        return this.clone();
    }
    withProperties(properties) {
        Object.assign(this.node, properties);
        return this.clone();
    }
    seedFieldsWith(fields) {
        this.node.fields = _.cloneDeep(fields);
        return this.clone();
    }
    validate(fieldGroup) {
        return isFieldGroupBlueprint(fieldGroup);
    }
}
